module.exports = __webpack_public_path__ + "media/form-type-page/file-alt-ce7a496c.svg";